import { ApiFilters } from '../../../core/models/interfaces/api-filters.interface';
import {
  ApiScenarioHistoryEntryResponseDto,
  ApiScenarioResponseDto,
} from '@birco/rainmesh-api';
import { startOfDay, subDays } from 'date-fns';

export const FEATURE_NAME = 'scenarioState';

export interface ScenarioState {
  entities: Record<string, ApiScenarioResponseDto>;
  history: ApiScenarioHistoryEntryResponseDto[];
  error: any | null;
  isLoading: boolean;
  filter: ScenarioFilter;
  historyFilter: ScenarioHistoryFilter;
  pages: Record<number, string[]>;
  totalCount: number;
  runningScenario: RunningScenario | null;
}

export interface RunningScenario {
  scenarioId: string;
  displayName: string;
  startedAt: string;
  runtimeMinutes: number;
}

export interface ScenarioFilter extends ApiFilters {}

export interface ScenarioHistoryFilter extends ApiFilters {
  startDate?: string;
  endDate?: string;
}

export const initialState: ScenarioState = {
  entities: {},
  history: [],
  filter: {
    page: 0,
    pageSize: 12,
  },
  historyFilter: {
    page: 0,
    pageSize: 20,
    startDate: startOfDay(subDays(new Date(), 3)).toISOString(),
  },
  pages: {},
  totalCount: 0,
  isLoading: false,
  error: null,
  runningScenario: null,
};
